import React, { createContext, useContext, useMemo } from 'react';

import { TTemplate } from '@wp-block-builder/package';

type TState = {
  configuration: TTemplate;
  layoutConfiguration: TTemplate | null;
  footerBody: JSX.Element | null;
};

const Context = createContext<TState | null>(null);
type TProps = {
  children: JSX.Element;
  configuration: TTemplate;
  footerBody: JSX.Element | null;
  layoutConfiguration: TTemplate | null;
};

export function Provider({ footerBody, children, configuration, layoutConfiguration }: TProps) {
  const value = useMemo<TState>(
    () => ({
      footerBody,
      configuration,
      layoutConfiguration,
    }),
    [footerBody, configuration, layoutConfiguration]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useDocumentStoreContext() {
  return useContext(Context)!;
}

export function useFooterBody() {
  return useDocumentStoreContext().footerBody;
}

export function useStrictVariablesRendering() {
  return useContext(Context)!.configuration.strictVariablesRendering;
}
